import React from "react";
import { Link } from "react-router-dom";

// Links to a category landing page (/learn/category/<slug>), served from Supabase.
// (Footer wraps this in its own <li>.)
const FooterLink = ({ title, category }) => (
  <Link to={`/learn/category/${category}`} style={{ textDecoration: "none" }}>
    {title}
  </Link>
);

export default FooterLink;
